(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
import React from 'react';
const SchemaResidentsFAQS = () => {
  return /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: `
        {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "Will I get my security deposit back?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "The return of your security deposit is pending the move-out inspection."
              }
            },
            {
              "@type": "Question",
              "name": "Can I use my security deposit for my last month of rent?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "No, California law prohibits this."
              }
            },
            {
              "@type": "Question",
              "name": "What happens if I need to break my lease?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Under this type of contract, you are agreeing to occupy the housing unit for a fixed amount of time. You are responsible for all rent payments through the lease term, even if you move out before the lease expires. If you move out prior to lease end, you are responsible for the rent or for finding a suitable replacement that must be pre-approved by Management."
              }
            },
            {
              "@type": "Question",
              "name": "What happens if my roommate wants to go, but I want to stay?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Subleasing is not allowed. Please work with Management to get approval to have someone added to or taken off the lease."
              }
            },
            {
              "@type": "Question",
              "name": "I lost my keys, what should I do?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Call Management at (800) 604-3430."
              }
            },
            {
              "@type": "Question",
              "name": "When is my first month's rent due?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "First month’s rent is due before you move in."
              }
            },
            {
              "@type": "Question",
              "name": "Where can I pay the rent?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Rent must be received on or before the first of every month. Tenants may pay rent online. You can pay rent online 24 hours a day, 7 days a week. Register your rent online here. Rent may also be mailed to: Community Builders Management - 424 N. Lake Avenue, Suite 200, Pasadena, CA 91101."
              }
            },
            {
              "@type": "Question",
              "name": "I am having trouble registering on the Residence Service Portal. Where can I find help?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Call Management at (800) 604-3430."
              }
            },
            {
              "@type": "Question",
              "name": "Are pets allowed?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, small pets (under 25 pounds) are allowed with a pet deposit and approval from Management."
              }
            },
            {
              "@type": "Question",
              "name": "How does my child apply for an apartment?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Applications can be found here. If your child is a full-time student, you will need to complete a guarantor application found here."
              }
            },
            {
              "@type": "Question",
              "name": "Who is responsible for paying the rent?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "All parties listed on the lease, including the guarantors, are responsible for rent throughout the term of the lease."
              }
            },
            {
              "@type": "Question",
              "name": "Can we complete the lease online?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes."
              }
            },
            {
              "@type": "Question",
              "name": "What documents do we need to provide to complete a lease agreement?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "You need to provide the following: government issued ID (driver license or state identification), proof of income (two most recent pay stubs) or parental guarantee form, proof of school enrollment (when applicable), credit screening, and $35 application fee per person and per guarantor."
              }
            },
            {
              "@type": "Question",
              "name": "What does a security deposit cover?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "It may cover many things, but it is generally used to pay for damage above and beyond normal wear and tear."
              }
            },
            {
              "@type": "Question",
              "name": "When is the first payment due?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Rent is due the first of every month. To secure your lease, you must pay the security deposit and first month’s rent."
              }
            },
            {
              "@type": "Question",
              "name": "Are there laundry facilities?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "All properties have washers and dryers located on-site. Some units offer a washer and dryer in the apartment."
              }
            },
            {
              "@type": "Question",
              "name": "Are pets allowed?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, small pets (under 25 pounds) are allowed with a pet deposit and approval from Management."
              }
            },
            {
              "@type": "Question",
              "name": "Is there security?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes. All our properties are located within the Department of Public Safety (DPS) zone. This means that USC Security provides additional cruiser and foot patrols and has community liaisons stationed throughout the zone."
              }
            },
            {
              "@type": "Question",
              "name": "Is the apartment furnished?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Furnished units are available for an additional charge upon request."
              }
            },
            {
              "@type": "Question",
              "name": "How do I pay the rent?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Rent must be received on or before the first of every month. Tenants may pay rent online. You can pay rent online(opens in new tab) 24 hours a day, 7 days a week. Click here to register. Rent may also be mailed to: Community Builders Management - 424 N. Lake Avenue, Suite 200, Pasadena, CA 91101."
              }
            }
          ]
        }
          `
    }
  });
};
const _default = SchemaResidentsFAQS;
export default _default;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(SchemaResidentsFAQS, "SchemaResidentsFAQS", "/var/www/html/websites/livecbm-com/src/frontend/components/Schemas/SchemaResidentsFAQS.jsx");
  reactHotLoader.register(_default, "default", "/var/www/html/websites/livecbm-com/src/frontend/components/Schemas/SchemaResidentsFAQS.jsx");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();